import { DEFAULT_SOUND } from 'cio/utils/push/defaults';

export const DEFAULT_RICH_PUSH_BODY_JSON = `{"link":"","custom_data":"{}","sound":"${DEFAULT_SOUND}"}`;
